import styled from 'styled-components';
import { Typography } from '../../../stories/atoms';
import { Button } from '../../../stories/molecules';

export const StyledTypography = styled(Typography)`
  color: ${({ theme: { palette, color } }) =>
    palette.mode === 'dark' ? color.secondaryDarkTextGray : color.secondaryTextGray};
`;

export const StyledButton = styled(Button)`
  flex: 1;
`;
